<!--
 * @Description: 轮播图
 * @Date: 2024-01-11 13:52:40
-->
<template>
  <div :style="{ '--count': count }" class="carousel">
    <div ref="carouselBody" class="carousel-body">
      <!-- 轮播图内容 -->
      <slot></slot>
    </div>
    <button class="carousel-prev" @click="prev">
      <BaseIcon><ArrowLeftBold /></BaseIcon>
    </button>

    <button class="carousel-next" @click="next">
      <BaseIcon><ArrowRightBold /></BaseIcon>
    </button>
  </div>
</template>

<script lang="ts" setup>
import { ref, onMounted, onUnmounted } from 'vue';
import { ArrowLeftBold, ArrowRightBold } from '@element-plus/icons-vue';
import { BaseIcon } from 'xrk-components';

const carouselBody = ref<HTMLDivElement>();
const count = ref(0);
const activeIndex = ref(0);
const isEnd = ref(false);
const isScroll = ref(false);

onMounted(() => {
  initItemStyle();
});
onUnmounted(() => {
  carouselBody.value?.removeEventListener('scroll', moveStart);
  carouselBody.value?.removeEventListener('scrollend', moveEnd);
});
const moveStart = () => (isScroll.value = true);
const moveEnd = () => (isScroll.value = false);
const initItemStyle = () => {
  count.value = carouselBody.value.children.length;
  carouselBody.value.addEventListener('scroll', moveStart);
  carouselBody.value.addEventListener('scrollend', moveEnd);
};

const move = async () => {
  return new Promise((resolve, reject) => {
    const firstDomLeft =
      carouselBody.value.children[0].getBoundingClientRect().left;
    carouselBody.value.scrollTo({
      left: (carouselBody.value.children[activeIndex.value] as HTMLDivElement)
        .offsetLeft,
      behavior: 'smooth'
    });
    setTimeout(() => {
      if (
        firstDomLeft ===
        carouselBody.value.children[0].getBoundingClientRect().left
      ) {
        reject('未移动');
      }
      resolve('移动成功');
    }, 300);
  });
};

const next = async (event?: Event) => {
  event?.preventDefault();
  if (isEnd.value || isScroll.value || activeIndex.value == count.value - 1)
    return;
  activeIndex.value += 1;
  try {
    await move();
  } catch (error) {
    console.log(error);
    next();
  }
};

const prev = async (event?: Event) => {
  event?.preventDefault();
  if (isScroll.value || activeIndex.value == 0) return;
  activeIndex.value -= 1;
  try {
    await move();
  } catch (error) {
    console.log(error);
    prev();
  }
};
</script>
<style scoped lang="scss">
.carousel {
  position: relative;
  &-body {
    overflow-x: hidden;
    gap: 24px;
    display: grid;
    grid-template-columns: repeat(var(--count, 3), 1fr);
    ::v-deep {
      & > div {
        position: relative;
        white-space: wrap;
      }
    }
  }
  &-next,
  &-prev {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    background: #ffffff;
    border-radius: 4px;
    border: 1px solid #d7dae2;
    position: absolute;
    right: -55px;
    z-index: 9;
    top: 50%;
    transform: translateY(-50%);
    cursor: pointer;
    &:hover {
      background: #f7f7f7;
    }
  }
  &-prev {
    left: -55px;
  }
  &-next {
    right: -55px;
  }

  &:has(.base-radio, .xrk-checkbox) {
    ::v-deep {
      .xrk-card {
        cursor: pointer;
      }
    }
  }
}
</style>
